/**
 * 统一处理API返回的数据
 * @param {*} resp: axios返回的对象
 * @param {*} emptyDefault（可选）: 指定当code === 1 时应该返回什么。
 */
const checkResp = function(resp, emptyDefault) {
    if (resp && (resp.code === 0 || resp.code === 1)) {
        if (resp.code === 1 && emptyDefault) {
            return emptyDefault;
        }
        return resp.data;
    }
    return Promise.reject(resp);
};

export default {
    install(Vue) {
        Vue.checkResp = checkResp;
        Object.defineProperty(Vue.prototype, '$checkResp', { value: Vue.checkResp });
    }
};



// WEBPACK FOOTER //
// ./src/assets/plugin/checkResp.js